import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    throwError as observableThrowError,
    Observable,
    BehaviorSubject,
    throwError,
    of,
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Response } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {
  authUrl = 'https://auth.chakaent.com/api/v1';
  constructor(
    private http: HttpClient,
    @Inject('baseUrl') private baseUrl: string) {}

    //fetch all user portfolio by productType
    portfolio(userId) {
        return this.http
            .get(this.baseUrl + `/portfolios/user/${userId}`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getProfile() {
      return this.http
          .get(this.authUrl + `/users/me`)
          .pipe(
            catchError(err => {
                return throwError(err);
            })
          )
  }

    getStatement(docType) {
      return this.http
          .get(this.baseUrl + `/assets/statements?productType=ADVISORY&docType=${docType}`)
         .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    positions() {
      return this.http
          .get(this.baseUrl + `/assets/positions?productType=ADVISORY`)
         .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getSettings(userid){
      return this.http
          .get(this.baseUrl + `/users/profile/${userid}`)
          .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    fetchPerformance(period, userID){
      return this.http
          .get(this.baseUrl + `/assets/performance?period=${period}&userId=${userID}&productType=ADVISORY`)
          .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

}
